import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MoreHoriz as MoreHorizIcon } from "@mui/icons-material";
import { IconButton, Menu, ThemeProvider, Tooltip, } from "@mui/material";
import React from "react";
import { theme } from "../Theme.js";
// need to override topbar theme
export const renderMenuWithTheme = (menu) => _jsx(ThemeProvider, { theme: theme, children: menu });
export const defaultRenderMenu = (menu) => menu;
export const MenuButton = ({ dataTestId, children, Icon, Button, buttonProps, menuProps, tooltip, closeOnClick = true, onToggle, renderMenu = defaultRenderMenu, disabled, hideWhenEmpty = true, menuSx, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
        onToggle?.(true);
    };
    const handleClose = (event) => {
        setAnchorEl(null);
        onToggle?.(false);
    };
    const shouldRenderMenu = hideWhenEmpty
        ? Array.isArray(children)
            ? children.some(child => !!child)
            : !!children
        : true;
    if (!shouldRenderMenu)
        return null;
    const button = Button ? (React.cloneElement(Button, {
        onClick: openMenu,
        onMouseDown: (e) => {
            e.stopPropagation();
        },
        onTouchStart: (e) => {
            e.stopPropagation();
        },
        "aria-haspopup": "true",
        "data-testid": dataTestId,
    })) : (_jsx(IconButton, { "aria-haspopup": "true", "data-testid": dataTestId, style: { flexShrink: 0, flexGrow: 0 }, color: "primary", size: "small", onClick: openMenu, onMouseDown: e => {
            e.stopPropagation();
        }, onTouchStart: e => {
            e.stopPropagation();
        }, disabled: disabled, ...buttonProps, children: Icon ?? _jsx(MoreHorizIcon, {}) }));
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: tooltip ?? "", children: button }), renderMenu(_jsx(Menu, { anchorEl: anchorEl, 
                // we need to keep it to `true` to allow open modals from menu items
                keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, onClick: e => {
                    e.stopPropagation();
                    if (anchorEl && closeOnClick)
                        handleClose(e);
                }, sx: [{ my: 0.5 }, ...(Array.isArray(menuSx) ? menuSx : [menuSx])], ...menuProps, slotProps: {
                    ...menuProps?.slotProps,
                    list: { disablePadding: true, ...menuProps?.slotProps?.list },
                }, children: children }))] }));
};
//# sourceMappingURL=MenuButton.js.map